import { render } from "./IconMoveToGroup.vue?vue&type=template&id=038c1458"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconMoveToGroup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "038c1458"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('038c1458', __exports__)) {
    api.reload('038c1458', __exports__)
  }
  
  module.hot.accept("./IconMoveToGroup.vue?vue&type=template&id=038c1458", () => {
    api.rerender('038c1458', render)
  })

}


export default __exports__